module.exports = __webpack_public_path__ + "static/media/about2.ea9f2440.png";